import { Component, ViewChild, ElementRef  } from '@angular/core';
import { NavController,NavParams,AlertController,ViewController,App,LoadingController, Loading} from 'ionic-angular';
//import { ListPage } from '../../pages/list/list';
//import { ListPage } from '../pages/list/list';
import { AuthService } from '../../providers/auth';
import { ListPage } from '../../pages/list/list';
//import { ThanksPage } from '../../pages/thanks/thanks';
//import { SignaturePage } from '../../pages/signature/signature';
//import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator';
import {
  GoogleMaps,
  GoogleMap,
  GoogleMapsEvent,
  GoogleMapOptions,
  CameraPosition,
  MarkerOptions,
  Marker,
  Environment
} from '@ionic-native/google-maps';

declare var google;

@Component({
  selector: 'page-ride',
  templateUrl: 'ride.html'
})

export class RidePage {
  loading: Loading;
  startbtn: boolean = true;
  drivestartbtn:boolean=true;
  dropbtn:boolean=true;

  tab1Root: any = ListPage;
  tab2Root: any = ListPage;
  pet:any;
  
  selectedItem: any;
  obj:any;
  obj2:any;
  obj3:any;
  items;
  items2;
  items3;
location;
task;
routeResponse;

 //  @ViewChild(Tabs) tabs;
  @ViewChild('map') mapElement: ElementRef;

    mainarray:any;
  map: any;
  markers = [];
    wayptsnavigation = [];
     //locationpyts=[];
  labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
     labelIndex = 0;
  start = '';
  end = '';
 
  directionsService = new google.maps.DirectionsService;
  directionsDisplay = new google.maps.DirectionsRenderer;

  constructor(public loadingCtrl: LoadingController,private alertCtrl: AlertController,public navCtrl: NavController,public authService:AuthService,public navParams: NavParams) {
    
    this.items = navParams.get('data');
    console.log(this.items);
     if(this.items.ridestatus!=5){
    let self = this;
this.task = setInterval(function () {
  self.ionViewWillEnter();
}, 30000);
}
  
  }
  presentConfirm() {
    let alert = this.alertCtrl.create({
      title: '',
      message: 'Are you sure ?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
       
          }
        }
      ]
    });
    alert.present();
  }
  

  autorefresh() {



  var point = {lat: this.items.driver_details.lat,lng:this.items.driver_details.long};
  //  var point = {lat: 48.391975, lng: 10.9184489};
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      zoom: 40,
      center: point,
      
     draggable:true,
      zoomControl: true,
      mapTypeControl: true,
      streetViewControl: false,
      fullscreenControl: false,
      
      mapTypeId: google.maps.MapTypeId.ROADMAP,
     
    });
 
}




  ionViewWillEnter() {

  this.initMap();
  this.start=this.items.pickup_direction;
   this.end=this.items.drop_direction;
  
   this.calculateAndDisplayRoute();

var locationpyts=[];
   for (var k = 0; k < this.items.passenger_details.length; k++) {
    if(k==0){
   locationpyts.push({
                indexid:k,
              location: this.items.passenger_details[k].address,
              text: 'Driver To '+this.items.passenger_details[k].address,

             // stopover: true
            });
            }else{
              locationpyts.push({
               indexid:k,
              location: this.items.passenger_details[k].address,
              text: this.items.passenger_details[k-1].address+' To '+this.items.passenger_details[k].address,

             // stopover: true
            });
            }
   }
  
   this.mainarray= locationpyts;


 
}
ionViewCanLeave(){

  clearInterval(this.task);
  }

  initMap() {
    
   

  if(this.items.ridestatus!=5){
   var point = {lat: this.items.driver_details.lat,lng:this.items.driver_details.long};
  //  var point = {lat: 48.391975, lng: 10.9184489};
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      zoom: 40,
      center: point,
      
     draggable:true,
      zoomControl: true,
      mapTypeControl: true,
      streetViewControl: false,
      fullscreenControl: false,
      
      mapTypeId: google.maps.MapTypeId.ROADMAP,
     
    });
}else{
   // var point = {lat: 48.391975, lng: 10.9184489};
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      zoom: 15,
     // center: point,
      
      draggable:false,
      zoomControl: false,
      mapTypeControl: false,
      streetViewControl: false,
       fullscreenControl: false,
        
      mapTypeId: google.maps.MapTypeId.ROADMAP,
     
    });
}
           



    this.createMapMarker(point);
 
  
    // directionsService = new google.maps.DirectionsService();
     // directionsDisplay = new google.maps.DirectionsRenderer();

     this.directionsDisplay.setMap(this.map);
    this.directionsDisplay.setOptions( {
     
   
     } );
     //this.directionsDisplay.setPanel(document.getElementById('right-panel'));
  }

calculateAndDisplayRoute() {
 var waypts = [];
 var checkboxArray = this.items.passenger_details;

console.log(checkboxArray.length);
        for (var i = 0; i < checkboxArray.length; i++) {
         if(i!=0 && i!=checkboxArray.length-1){
            waypts.push({
              location: checkboxArray[i].address,

             // stopover: true
            });

             this.wayptsnavigation.push({
              location: checkboxArray[i].address,

             // stopover: true
            });
            
             
            }
         
        }
  console.log('checkboxArray');
   
 console.log(waypts);
  console.log('checkboxArray2');

    this.directionsService.route({origin: this.start,
    destination: this.end,
    waypoints: waypts,
    optimizeWaypoints: true,
     travelMode: google.maps.TravelMode['DRIVING']
    // provideRouteAlternatives: true
    }, (response, status) => {
  
        this.directionsDisplay.setDirections(response);
        console.log(response);
 
            
    
    });
  }





  private createMapMarker(place:any):void {
   
    var marker = new google.maps.Marker({
    map: this.map,
    position: place,
    icon:'../assets/imgs/taxi.png'
    //label: '1',
    //label: labels[labelIndex++ % labels.length]

    });
    this.markers.push(marker);
    }

    
}



// WEBPACK FOOTER //
// ./src/pages/ride/ride.ts